"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rgsTheme = void 0;
exports.rgsTheme = {
    'thema-id': 'rgs-agent-1',
    logo: 'url',
    common: {
        radius: '4px',
        radius12: '12px',
        radiusXXS: '4px',
        radiusXS: '8px',
        radiusS: '12px',
        radiusM: '12px',
        radiusL: '12px',
        radiusXL: '12px',
        'font-family': 'Roboto Flex',
        'icons-toggle': true,
        'icons-url-prefix': '-pick-',
        'box-shadow': 'box-shadow: 0px 8px 25px rgba(99, 119, 156, 0.2)',
        outlined: false,
        a: {
            color: '#1698D9',
            decoration: 'none',
        },
    },
    colors: {
        surface: {
            primary: '#FFFFFF',
            secondary: '#F5F7F9',
            background: '#F2F2F5',
            brand: '#D70E4B',
            brand2: '#B70037',
            accent: '#1698D9',
            interactive: {
                'interactive-tined': '#F2D4E2',
                'interactive-light': '#FDEBF0',
            },
            success: {
                'success-tined': '#BAF8C8',
                'success-light': '#D1FADA',
            },
            warning: {
                'success-tined': '#EDDCC4',
                'success-light': '#F3E7D8',
            },
            error: {
                'success-tined': '#F7C4D2',
                'success-light': '#FADBE4',
            },
            'matt-glass': {
                'success-tined': {
                    background: 'gba(255, 255, 255, 0.8)',
                    'background-filter-blur': '32px',
                },
                'success-light': {
                    background: 'rgba(241, 242, 246, 0.8)',
                    'background-filter-blur': '32px',
                },
            },
        },
        text: {
            primary: '#1F232B',
            inverse: '#FFFFFF',
            secondary: '#737B8C',
            tertiary: '#A2ADC1',
            interactive: '#1698D9',
            'interactive-clarified': '#0088CC',
            success: '#15BC3A',
            warning: '#FF8833',
            error: '#E33368',
        },
        neutral: {
            '0': '#FFFFFF',
            '10': '#F1F2F6',
            '20': '#E4E7EE',
            '30': '#DCE1EF',
            '50': '#A2ADC1',
            '70': '#8591A9',
            '80': '#63779C',
            '100': '#1F232B',
        },
        accent: {
            interactive: {
                normal: '#1698D9',
                darkened: '#0088CC',
                clarified: '#6EC9F7',
                faded: '#9EDBFA',
            },
            action: {
                normal: '#D70E4B',
                darkened: '#B70037',
                clarified: '#F2D4E2',
                faded: '#F8E8EF',
            },
            success: {
                normal: '#15BC3A',
                darkened: '#198530',
                clarified: '#BCFBC9',
                faded: '#D1FADA',
            },
            warning: {
                normal: '#C88C46',
                darkened: '#946B38',
                clarified: '#F1DDC6',
                faded: '#F3E7D8',
            },
            error: {
                normal: '#E33368',
                darkened: '#B0274D',
                clarified: '#FAC7D5',
                faded: '#FADBE4',
            },
        },
        'on-accent': {
            primary: '#FFFFFF',
            darkened: '#E4E4E5',
            secondary: '#505254',
            tertiary: 'background: rgba(252, 252, 255, 0.4)',
            quaternary: 'rgba(252, 252, 255, 0.2)',
        },
        overlay: {
            primary: 'rgba(31, 35, 43, 0.5)',
            secondary: 'rgba(90, 97, 128, 0.1)',
            ripple: {
                interactive: 'rgba(22, 152, 217, 0.15)',
                success: 'rgba(51, 204, 102, 0.15)',
                warning: ' rgba(255, 136, 51, 0.15)',
                error: 'rgba(243, 86, 106, 0.15)',
            },
        },
        gradient: {
            home: 'linear-gradient(103.18deg, #F53D55 8.82%, #B14C98 37.31%, #5864E1 65.8%, #25A4F4 94.29%)',
            health: 'linear-gradient(180deg, #0E91E4 0.01%, #44FDAF 100%)',
            pet: 'linear-gradient(315deg, #EA66FF 0%, #FF5C69 50%, #FFAA00 100%)',
            sport: 'linear-gradient(135deg, #1AA1E5 0%, #0BDAC9 50%, #C4EA06 100%)',
            'anti-mite': 'linear-gradient(345.96deg, #F199FF 0%, #5C33FF 100%)',
        },
        icon: {
            primary: '#1F232B',
            inverse: '#FFFFFF',
            secondary: '#FEECF1',
            tertiary: '#D70E4B',
            success: '#15BC3A',
            quaternary: '#505254',
            warning: '#FF8833',
            error: '#E33368',
        },
        product: {
            travel: '#D9EDFF',
            apartment: '#FFF3DC',
            house: '#FFEECF',
            mortgage: '#F5F5F5',
            sport: '#D4FCFF',
            pet: '#FFEFF8',
            antimite: '#E1FAC9',
            health: '#DEFFDF',
            partner: '#F6E2FF',
        },
        additional: {
            light: {
                yellow: '#FFF3DC',
                orange: '#FFE0CF',
                green: '#DEFFDF',
                blue: '#D4FCFF',
                lime: '#E1FAC9',
                'dark-blue': '#D9EDFF',
                pink: '#FFEFF8',
                neutral: '#F5F5F5',
                purple: '#F6E2FF',
            },
            darkened: {
                yellow: '#B87900',
                orange: '#B84000',
                green: '#00B806',
                blue: '#00ABB8',
                lime: '#5AA810',
                'dark-blue': '#0061B8',
                pink: '#B80067',
                neutral: '#5C5C5C',
                purple: '#7F00B8',
            },
            partners: {
                gosuslugi: '#0D4CD3',
            },
        },
    },
    components: {
        risks: {
            'text-toggle': true,
            'icons-toggle': true,
            'icons-url-prefix': '-pick-',
        },
    },
};
